
import { DaButtonGroup, DaButton } from '@daiso/design-system'
// import Vue from 'vue'
export default {
  name: 'Dialog',
  components: { DaButtonGroup, DaButton },
  emmits: ['close'],
  props: {
    showClose: {
      type: Boolean,
      default: false,
    },
    dialogVisible: {
      type: Boolean,
      default: false,
    },
    useSize: {
      type: String,
      default: 'xs'
    },
    title: {
      type: String,
      default: undefined
    },
    titleSlot: {
      type: Boolean,
      default: false,
    },
    useFooter: {
      type: Boolean,
      default: false,
    },
    isConfirm: {
      type: Boolean,
      default: false,
    },
    closeOnClickModal: {
      type: Boolean,
      default: true,
    }
  },
  setup (props, ctx) {
    const close = () => ctx.emit('close')
    return { close }
  },
  data: function () {
    return {
      visible: false,
      sizeType: {
        xxs: 'xxs',
        xs: 'xs',
        sm: 'sm',
        md: 'md',
        lg: 'lg',
        full: 'full',
        fit: 'fit'
      },
    }
  },
  watch: {
    dialogVisible: function (newVal, oldVal) {
      newVal ? this.openMenu() : this.closeMenu()
    },
  },
  created () {
    if (this.dialogVisible) {
      this.openMenu()
    }
  },
  methods: {
    openMenu () {
      this.visible = true
    },
    closeMenu (isBack = true) {
      this.visible = false
    }
  },
}
